import { css, cx } from "@emotion/css"

import COLOR_CODE from "../../../features/oneClickEstimate/pcb/constant/color"

type Props = {
  options: { label: string; value: string }[]
  value?: string | null
  hasError?: boolean
} & Omit<JSX.IntrinsicElements["select"], "value">

const Select = ({ options, value, hasError = false, ...props }: Props) => {
  const className = cx(styles.select, hasError && styles.invalid)

  return (
    <select {...props} value={value ?? ""} className={className}>
      <option style={{ display: "none" }}>選択してください</option>
      {options.map(({ label, value }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  )
}

export default Select

const styles = {
  select: css`
    height: 28px;
    padding: 0 8px;
    font: inherit;
    background: linear-gradient(#fafafa, #e6e6e6);
    border-color: #8e8c9b;
    border-radius: 4px;
    &:focus {
      border-color: #4488ee;
      outline: none;
      box-shadow: 0px 0px 3px #e6e6e6 inset, 0px 0px 2px #4488ee;
    }
  `,
  invalid: css`
    border-color: ${COLOR_CODE.RED};
  `,
}
